<template>
  <div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <h2>{{ $t('Custom Audiences connected on ZWIZ') }}</h2>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control">
            <input
              type="text"
              name="search"
              id="search"
              v-model="search"
              :placeholder="$t('Search')"
            />
          </div>
        </v-flex>
      </v-layout>
      <v-data-table
        :rows-per-page-items="[25, 40, 50, 100]"
        :loading="loading"
        :headers="headers"
        :items="filterAudience"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr @click="modelContent(props.item)">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ timeToDate(props.item.time_updated) }}</td>
            <td class="text-xs-left">
              <v-btn
                :loading="loadingDelete"
                fab
                small
                outline
                color="primary"
                @click.stop="deleteCustomAudience(props.item)"
                ><v-icon>delete</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h2>Custom Audience Content</h2>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <p class="mb-2">ชื่อกลุ่มเป้าหมาย</p>
                <span>{{ dataDialog.name }} </span>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="mb-2">ขนาดกลุ่มเป้าหมายโดยประมาณ</p>
                <span
                  >{{ dataDialog.approximate_count_lower_bound }} -
                  {{ dataDialog.approximate_count_upper_bound }}
                </span>
              </v-flex>
              <v-flex xs12 sm6>
                <p class="mb-2 mt-3">ประเภท</p>
                <span
                  >{{ dataDialog.is_created_by_zwiz ? 'สร้างจาก Zwiz' : 'สร้างจาก Facebook' }}
                </span>
              </v-flex>

              <v-flex xs12 sm6>
                <p class="mb-2 mt-3">สร้างแล้ว</p>
                <span>{{ timeToDate(dataDialog.time_created) }} </span>
              </v-flex>

              <v-flex xs12 sm6>
                <p class="mb-2 mt-3">อัพเดตล่าสุด</p>
                <span>{{ timeToDate(dataDialog.time_updated) }} </span>
              </v-flex>
            </v-layout>
            <div class="mt-3 text-xs-center">
              <v-btn outline color="primary" flat @click="dialog = false">ยืนยัน</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  components: {},
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Data', align: 'start', sortable: false, value: 'Data' },
        { text: '', value: '', sortable: false }
      ],
      loading: false,
      dataTable: [],
      dialog: false,
      dataDialog: {},
      loadingDelete: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterAudience() {
      return this.dataTable.filter(item => {
        return this.$t(item.name)
          .toLowerCase()
          .includes(this.search.toLowerCase())
      })
    }
  },
  mounted() {
    this.getCustomAudience()
  },
  methods: {
    modelContent(item) {
      this.dataDialog = item
      this.dialog = true
    },
    timeToDate(timestamp) {
      timestamp = new Date(timestamp * 1000)
      return dayjs(timestamp).format('DD/MM/YYYY HH:mm:ss')
    },
    async deleteCustomAudience(data) {
      var vm = this
      vm.$swal
        .fire({
          title: this.$t('Do you want to delete {name}?', {
            name: data.name
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(async result => {
          if (result.value) {
            vm.loadingDelete = true
            var responseDelete = await api.deleteCustomAudience({
              pageid: this.selectedBot.pageid,
              id: data.id
            })
            if (responseDelete.success) {
              this.dataTable = this.dataTable.filter(function(item) {
                return item.id !== data.id
              })
              await this.$swal({
                title: this.$t('Successfully'),
                text: this.$t('your custom audience has been deleted.'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                reverseButtons: true
              })
            } else {
              vm.$swal.fire({
                title: vm.$t('Something went wrong'),
                text: vm.$t("Can't connect"),
                type: 'error'
              })
            }
            vm.loadingDelete = false
          }
        })
    },
    async getCustomAudience() {
      var vm = this
      try {
        vm.loading = true
        const response = await api.getCustomAudience({ pageid: vm.selectedBot.pageid })
        if (response.success) {
          vm.dataTable = response.result
        }
        vm.loading = false
      } catch (error) {
        vm.loading = false
        vm.$swal
          .fire({
            title: vm.$t('Something went wrong'),
            text: vm.$t(
              'No Custom audience has been created. Please create your custom audience again on “Users” tap.'
            ),
            type: 'error'
          })
          .then(result => {
            if (result.value) {
              vm.$emit('Back')
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/customAudience/HistoryAudience.vue